import { render, staticRenderFns } from "./upgradeSummary.vue?vue&type=template&id=0b5c0e3f&scoped=true"
import script from "./upgradeSummary.vue?vue&type=script&lang=js"
export * from "./upgradeSummary.vue?vue&type=script&lang=js"
import style0 from "./upgradeSummary.vue?vue&type=style&index=0&id=0b5c0e3f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5c0e3f",
  null
  
)

export default component.exports